export enum SignupTokenType {
  INVITE_INITIATIVE = "INVITE_INITIATIVE",
  INVITE_SURVEY = "INVITE_SURVEY",
  FREE_TRIAL = "FREE_TRIAL",
}